"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var css_1 = require("@emotion/css");
var merge_refs_1 = __importDefault(require("merge-refs"));
var react_1 = __importStar(require("react"));
var MenuContext_1 = require("./MenuContext");
var menuItemStyle = function (selectedTheme) { return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  border: none;\n  width: 100%;\n  background-color: unset;\n  text-align: start;\n  margin: 0;\n  cursor: pointer;\n  padding: 12px 16px;\n  ", ";\n  color: ", ";\n\n  :focus {\n    outline: none;\n  }\n"], ["\n  display: block;\n  border: none;\n  width: 100%;\n  background-color: unset;\n  text-align: start;\n  margin: 0;\n  cursor: pointer;\n  padding: 12px 16px;\n  ", ";\n  color: ", ";\n\n  :focus {\n    outline: none;\n  }\n"])), (0, design_system_foundations_1.expandFontTheme)((0, design_system_foundations_1.addFontThemePrefix)(selectedTheme, 'body')), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.neutral100, dark: design_system_foundations_1.theme.color.white })); };
var menuItemHighlightedStyle = function (selectedTheme) { return (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.teal10, dark: design_system_foundations_1.darkTheme.color.prussianBlue })); };
var menuItemDisabledStyle = (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  opacity: 0.4;\n  cursor: not-allowed;\n"], ["\n  opacity: 0.4;\n  cursor: not-allowed;\n"])));
exports.MenuItem = (0, react_1.forwardRef)(function (_a, ref) {
    var _b;
    var _c;
    var className = _a.className, index = _a.index, children = _a.children, disabled = _a.disabled, onClick = _a.onClick, onKeyDown = _a.onKeyDown, testId = _a.testId, rest = __rest(_a, ["className", "index", "children", "disabled", "onClick", "onKeyDown", "testId"]);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var _d = react_1.default.useContext(MenuContext_1.MenuContext), getItemProps = _d.getItemProps, highlightedIndex = _d.highlightedIndex;
    var buttonRef = (0, react_1.useRef)(null);
    var _e = (_c = getItemProps === null || getItemProps === void 0 ? void 0 : getItemProps(index !== null && index !== void 0 ? index : 0, { onClick: onClick, onKeyDown: onKeyDown })) !== null && _c !== void 0 ? _c : {
        ref: undefined,
        onClick: onClick,
        onKeyDown: undefined,
    }, isHighlighted = _e.isHighlighted, itemProps = __rest(_e, ["isHighlighted"]);
    return (react_1.default.createElement("button", __assign({ key: index }, rest, itemProps, { "data-testid": testId, role: "menuitem", ref: (0, merge_refs_1.default)(itemProps === null || itemProps === void 0 ? void 0 : itemProps.ref, buttonRef, ref), onClick: function (event) {
            var _a;
            (_a = itemProps === null || itemProps === void 0 ? void 0 : itemProps.onClick) === null || _a === void 0 ? void 0 : _a.call(itemProps, event);
        }, disabled: disabled, onKeyDown: function (event) {
            var _a;
            (_a = itemProps === null || itemProps === void 0 ? void 0 : itemProps.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(itemProps, event);
        }, className: (0, css_1.cx)(menuItemStyle(selectedTheme), (_b = {},
            _b[menuItemHighlightedStyle(selectedTheme)] = highlightedIndex === index,
            _b[menuItemDisabledStyle] = disabled,
            _b), className, 'ds-menu-item'), type: "button" }), typeof children === 'function' ? children(__assign(__assign({}, itemProps), { isHighlighted: isHighlighted })) : children));
});
exports.MenuItem.displayName = 'MenuItem';
var templateObject_1, templateObject_2, templateObject_3;
